<script lang="ts" setup>
import RoomieButton from '@lahaus-roomie/roomie/src/components/RoomieButton/index.vue'
import RoomieCardLink from '@lahaus-roomie/roomie/src/components/RoomieCardLink/index.vue'
import type { Option, Props } from './types'
import './_index.scss'

defineProps<Props>()
const { t, rt, tm } = useI18n()
const emit = defineEmits(['submit', 'skip'])

const options = tm('options') as Array<Option>

const handleOptionClick = (value: string) => {
  emit('submit', { name: 'bedroomsNumber', value: parseInt(value) })
}

const handleSkip = () => {
  emit('skip', { name: 'bedroomsNumber', value: null })
}
</script>

<script lang="ts">
export default {
  name: 'OnboardingStepsBedroomsNumber'
}
</script>

<template>
  <section class="onboarding-steps-bedrooms-number">
    <h2 class="text-carbon-800 text-20 font-semibold mb-8 text-center">
      {{ t('title') }}
    </h2>

    <div class="onboarding-steps-bedrooms-number__options-holder">
      <RoomieCardLink
        v-for="(option, index) in options"
        :id="`bedrooms-number-option-${index}`"
        :key="`bedrooms-number-option-${index}`"
        :data-lh-id="`onboarding-bedrooms-number-option-${index}`"
        class="cursor-pointer"
        container-tag="div"
        :title="rt(option.label)"
        :interactive="true"
        :can-right-arrow="true"
        @click="() => handleOptionClick(rt(option.value))" />
    </div>

    <div class="w-full mt-12 flex justify-center">
      <RoomieButton
        id="onboarding-steps-bedrooms-number-skip-button"
        data-lh-id="onboarding-steps-bedrooms-number-skip-button"
        type="button"
        :aria-label="t('skipCta')"
        variant="ghost"
        @click="handleSkip">
        {{ t('skipCta') }}
      </RoomieButton>
    </div>
  </section>
</template>

<i18n src="./i18n.json" lang="json" />
